class McElement extends HTMLElement {
    version = '2.1.8'
    constructor(){
        super();
        this.addEventListener(MCEVENTS.RESET, this.reset);
    }
    activate = () => {
        this.classList.add('mc-active');
        this.afterOpen();
    }
    deactivate = () => {
        this.classList.remove('mc-active');
        this.afterClose();
    }

    toggle = () => {
        this.isActive() ? this.deactivate() : this.activate();
    }

    isActive = () => {
        return this.classList.contains('mc-active');
    }
    
    reload = (doc) => {
        const newContent = doc.querySelector(`#${this.id}`);
        this.innerHTML = newContent.innerHTML;
        this.afterReload();
    }
    
    registerReference = (reference) => {
        if(!this.references){
            this.references = new Array();
        }
        this.references.push(reference);
    }



    reset = () => { this.deactivate(); }

    /* Accessibilità: elementi che possono ricevere focus e sono resi (WCAG 2.1.1, 2.4.3). */
    focusables = (rootElement = this) => {
        const selector = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
        return Array.from(rootElement.querySelectorAll(selector)).filter(el => el.getClientRects().length > 0 && !el.closest('[inert]'));
    }

    /* Tab e Shift+Tab restano dentro rootElement finché il pannello è aperto. */
    trapTab = (e, rootElement = this) => {
        if(e.key !== 'Tab'){
            return;
        }
        const items = this.focusables(rootElement);
        if(items.length == 0){
            e.preventDefault();
            return;
        }
        const first = items[0];
        const last = items[items.length - 1];
        if(e.shiftKey && (document.activeElement === first || !rootElement.contains(document.activeElement))){
            e.preventDefault();
            last.focus();
        }
        else if(!e.shiftKey && (document.activeElement === last || !rootElement.contains(document.activeElement))){
            e.preventDefault();
            first.focus();
        }
    }

    afterOpen = () => {}
    afterClose = () => {}
    afterReload = () => {}

    
}

window.McElement = McElement;